import React from 'react';
import './Icon.css';

const ICON_URL = 'https://files.jdplc.com/images/icons';
const PDF_ICON_URL = ICON_URL + '/pdf';

export const PDFIcon = ({ name, style }) => {
    return (
        <i
            className={'icon--pdf'}
            style={{
                backgroundImage: `url(${PDF_ICON_URL}/${name})`,
                ...style,
            }}
        />
    );
};
